/*
  Barra de progreso hacia el despacho gratis.

  El estado inicial lo pinta Liquid. Después hay que reaccionar a cada cambio
  del carrito, y Dawn no expone un evento global para eso: su pubsub es interno
  del módulo. En vez de acoplarnos a esa implementación, observamos el contador
  del ícono del carrito —que Dawn siempre actualiza— y ahí releemos /cart.js.
*/
class MateryEnvioGratis extends HTMLElement {
  connectedCallback() {
    this.umbral = parseInt(this.dataset.umbral, 10);
    if (!(this.umbral > 0)) return;

    this.texto = this.querySelector('[data-texto]');
    this.barra = this.querySelector('[data-barra]');
    this.relleno = this.querySelector('[data-relleno]');

    this.formato = new Intl.NumberFormat('es-CL', {
      style: 'currency',
      currency: this.dataset.moneda || 'CLP',
      maximumFractionDigits: 0,
    });

    this.publicarAlto();
    this.observarCarrito();
  }

  /*
    El padding inferior del body sale de aquí. Antes era un valor fijo y no
    coincidía con el alto real de la barra —que cambia con el largo del mensaje
    y el ancho de pantalla—, así que sobraba blanco al final de la página.
  */
  publicarAlto() {
    const medir = () => {
      document.documentElement.style.setProperty(
        '--matery-envio-alto',
        `${this.offsetHeight}px`
      );
    };

    medir();

    if ('ResizeObserver' in window) {
      this.observadorAlto = new ResizeObserver(medir);
      this.observadorAlto.observe(this);
    } else {
      window.addEventListener('resize', medir, { passive: true });
    }
  }

  observarCarrito() {
    const burbuja = document.getElementById('cart-icon-bubble');
    if (!burbuja) return;

    // Un cambio en el contador significa que el carrito se movió.
    this.observer = new MutationObserver(() => this.refrescar());
    this.observer.observe(burbuja, { childList: true, subtree: true, characterData: true });
  }

  disconnectedCallback() {
    if (this.observer) this.observer.disconnect();
    if (this.observadorAlto) this.observadorAlto.disconnect();
  }

  async refrescar() {
    // Varias mutaciones seguidas describen un mismo cambio: basta la última.
    clearTimeout(this.pendiente);
    this.pendiente = setTimeout(async () => {
      try {
        const r = await fetch(`${window.Shopify.routes.root}cart.js`);
        if (!r.ok) return;
        const carrito = await r.json();
        this.pintar(carrito.total_price, carrito.item_count);
      } catch (e) {
        // Si la consulta falla dejamos el último estado válido a la vista.
      }
    }, 120);
  }

  pintar(total, items) {
    const falta = this.umbral - total;

    let mensaje;
    let avance;

    if (items === 0) {
      mensaje = this.dataset.vacio.replace('[monto]', this.moneda(this.umbral));
      avance = 0;
    } else if (falta > 0) {
      mensaje = this.dataset.falta.replace('[monto]', this.moneda(falta));
      avance = Math.min(100, Math.round((total / this.umbral) * 100));
    } else {
      mensaje = this.dataset.logrado;
      avance = 100;
    }

    this.texto.textContent = mensaje;
    this.relleno.style.width = `${avance}%`;
    this.barra.setAttribute('aria-valuenow', avance);
  }

  /* Los totales de Shopify vienen en la unidad menor de la moneda. */
  moneda(valor) {
    return this.formato.format(valor / 100);
  }
}

customElements.define('matery-envio-gratis', MateryEnvioGratis);
